import inboxRoutes from './inbox';
import jobRoutes from './jobs';
const routes = [
    inboxRoutes,
    jobRoutes
];
export default routes;
